import { render, staticRenderFns } from "./AlertsPage.vue?vue&type=template&id=0ad2d78a&scoped=true&"
import script from "./AlertsPage.vue?vue&type=script&lang=js&"
export * from "./AlertsPage.vue?vue&type=script&lang=js&"
import style0 from "./AlertsPage.vue?vue&type=style&index=0&id=0ad2d78a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad2d78a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ad2d78a')) {
      api.createRecord('0ad2d78a', component.options)
    } else {
      api.reload('0ad2d78a', component.options)
    }
    module.hot.accept("./AlertsPage.vue?vue&type=template&id=0ad2d78a&scoped=true&", function () {
      api.rerender('0ad2d78a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/alerts/AlertsPage.vue"
export default component.exports